import { FieldKey } from '../i18n';

import { validateReservedWords } from './reserved-words';

const validateDeveloperName = (
    value: string,
    isAdmin: boolean,
    fieldName: FieldKey = 'field-developer-name',
): string => (isAdmin ? '' : validateReservedWords(value.toLowerCase(), fieldName));

export default validateDeveloperName;
